import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage'

const getApiUrl = () => {
  const stageUrl = getItemFromLocalStorage('stageUrl')

  if (
    window.location.hostname === 'www.panenkafc.gg' ||
    window.location.hostname === 'panenkafc.gg' ||
    window.location.hostname === 'fan-club-a59.pages.dev' ||
    getItemFromLocalStorage('isProd')
  ) {
    return 'https://panenkafc-services-xgjiw.ondigitalocean.app'
  } else if (stageUrl) {
    return stageUrl
  } else {
    return 'https://lobster-app-sgwxa.ondigitalocean.app'
  }
}

export default getApiUrl
